import { format, isValid, parseISO } from "date-fns";
import { enGB } from "date-fns/locale";

function parsePublicDate(value: string): Date {
  if (value.includes("T")) return parseISO(value);
  return parseISO(`${value}T00:00:00`);
}

/** Stable across SSR (Node) and browser — avoids toLocaleDateString hydration mismatches. */
export function formatPublicDateShort(value: string): string {
  const date = parsePublicDate(value);
  if (!isValid(date)) return value;
  return format(date, "d MMM yyyy", { locale: enGB });
}

export function formatPublicDateLong(value: string): string {
  const date = parsePublicDate(value);
  if (!isValid(date)) return value;
  return format(date, "d MMMM yyyy", { locale: enGB });
}

export function formatPublicMonthYear(value: Date | string | null | undefined): string {
  if (!value) return "Not yet published";
  const date = typeof value === "string" ? parsePublicDate(value) : value;
  if (!isValid(date)) return "Not yet published";
  return format(date, "MMMM yyyy", { locale: enGB });
}
